import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import Coaching from "@/components/Coaching";
import Programs from "@/components/Programs";
import FreeGuide from "@/components/FreeGuide";
import Universe from "@/components/Universe";
import Blog from "@/components/Blog";
import Results from "@/components/Results";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const LandingPage = () => (
  <main data-testid="landing-page" className="bg-[#050505] text-white">
    <Header />
    <Hero />
    <Marquee />
    <Story />
    <Coaching />
    <Programs />
    <FreeGuide />
    <Universe />
    <Blog />
    <Results />
    <Contact />
    <Footer />
  </main>
);

export default LandingPage;
